import Image from "next/image";
import { container_classname } from "./constants";

interface ComparisonData {
    imageUrl: string;
    title: string;
    description: string;
}

interface WhyYourWebsiteNeedThisData {
    mainTitle?: string;
    comparisonData?: ComparisonData[];
}

const defaultComparisonData: ComparisonData[] = [
    {
        imageUrl: "https://assets.gallabox.com/gb-home/free-tools/ai-chatbot/why-gallabox/store.png",
        title: "You have a physical store:",
        description: "Visitors come in, your store staff greet them and help them with more details about your products/services. Great, you have your prospect covered ✅",
    },
    {
        imageUrl: "https://assets.gallabox.com/gb-home/free-tools/ai-chatbot/why-gallabox/website.png",
        title: "You have a website:",
        description: "Visitors come in, browse your products/services. They have doubts. They try to find answers on your website. But it's not an intuitive experience ❌",
    },
];

const WhyYourWebsiteNeedThis: React.FC<WhyYourWebsiteNeedThisData> = (props) => {
    const { mainTitle = "Why your business needs a WhatsApp AI chatbot", comparisonData = defaultComparisonData } = props;
    return (
        <section className={`${container_classname} lg:py-20 pt-12 pb-20 relative`}>
            <h2 className="md:text-6xl text-3xl font-semibold md:mb-12 mb-6" style={{ fontFamily: "Degular Display" }}>
                {mainTitle}
            </h2>
            <div className="w-full flex lg:flex-row flex-col lg:gap-5 gap-6">
                {comparisonData.map((data, index) => {
                    const { imageUrl, title, description } = data;
                    return (
                        <div key={index} className="lg:w-1/2 w-full lg:mx-0 mx-auto">
                            <Image width={610} height={338} src={imageUrl} alt={title} />
                            <div className="lg:px-6 px-4 lg:py-8 py-5 border border-solid border-gray-200 border-t-0 rounded-b-lg">
                                <h6 className="lg:text-3xl text-xl font-semibold mb-6">{title}</h6>
                                <p className="lg:text-xl text-base">{description}</p>
                            </div>
                        </div>
                    );
                })}
            </div>
            <div className="absolute left-auto" style={{ right: "42%" }}>
                <Image width={86} height={142} src={"https://assets.gallabox.com/gb-home/free-tools/ai-chatbot/curved-arrow.png"} alt="curved arrow" />
            </div>
        </section>
    );
};

export default WhyYourWebsiteNeedThis;
